<template>
  <form @submit.prevent="upload()" id="formdocument" class="float-right" style="margin-top: -5px;">
    <div class="text-center text-lg-right">
      <label class="btn btn-primary disabled" v-if="uploading">
        <font-awesome-icon icon="spinner" class="fa-spin"/> Adjuntando
      </label>
      <label class="btn btn-primary" v-else>
        <font-awesome-icon icon="file-upload"/> {{ texto }}<input type="file" name="file" id="fileinput" hidden @change="upload()">
      </label>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() { 
    return {
      uploading: false
    }
  },
  props: {
    tipoObjeto: {
      default: null
    },
    idObjeto: {
      default: null
    },
    texto: {
      default: 'Adjuntar'
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase'
    })
  },
  methods: {
    upload() {
      this.uploading = true;

      // Sacamos elemntos
      let form = document.getElementById('formdocument');
      let fileInput = document.getElementById('fileinput');

      // Filename y extension
      let fileName = "";
      let trozos = fileInput.value.split(".");
      for (let i = 0; i < trozos.length; i++) {
        if (i < trozos.length - 1) {
          fileName += trozos[i];
        }
      }
      fileName = fileName.split("\\")[fileName.split("\\").length - 1];
      let extension = '.' + trozos[trozos.length - 1];
      
      // Formdata
      let formData = new FormData(form);
      formData.append('tipoObjeto', this.tipoObjeto);
      formData.append('idObjeto', this.idObjeto);
      formData.append('fileName', fileName);
      formData.append('extension', extension);
      formData.append('publicable', 1);
      formData.append('publicableCliente', 1);

      // Peticion
      let url = this.urlBase + "archivodocumental";
      this.$http.post(url, formData).then(
        response => {
          fileInput.value = null;
          this.uploading = false;
          this.$emit('uploaded', response)
        },
        error => {
          this.uploading = false;
        }
      )
    }
  }
}
</script>

